// Polis in the new interface: the page, the election, the "New election" dialog (10 October 2026).
export default {
  onglets: {
    projection: 'Projections',
    candidats: 'Candidates',
    electorat: 'Electorate',
    scenarios: 'Scenarios',
    sonar: 'Sonar',
    registre: 'Register',
    scrutin: 'Election settings',
  },
  dans: 'in {n} days',
  demain: 'tomorrow',
  aujourdhui: 'today',
  chargement: 'Reading the elections…',
  erreur: 'The elections could not be read.',
  fermer: 'Close',
  aucune: {
    titre: 'No election yet',
    texte: 'An election takes a few fields: Orion then reads up on its rules, calendar, candidates and campaign, and prepares the electorate.',
    creer: 'New election',
  },
  preparation: {
    titre: 'Orion is preparing this election',
    texte: 'It reads the rules, the calendar, the lists or candidates, their profiles and the state of the campaign. The page updates by itself.',
  },
  echec: {
    titre: 'Orion could not prepare this election',
    inconnue: 'The reason is unknown.',
  },
  nouvelle: {
    titre: 'New election',
    chapeau: 'Orion reads the rules, calendar, candidates and campaign, then prepares the electorate. Allow a few minutes.',
    pays: 'Country',
    jour: 'Election day',
    scrutin: 'Voting system',
    types: {
      proportionnel: { titre: 'Proportional', texte: 'Seats, a threshold, blocs and a majority: the Knesset, proportional legislative elections.' },
      'deux-tours': { titre: 'Two rounds', texte: 'A first round in percentages and two qualifiers: a presidential election.' },
      majoritaire: { titre: 'One round', texte: 'A single round, first past the post: a US Senate race, a runoff.' },
    },
    nom: 'Election name',
    nomExemple: 'Presidential election',
    consignes: 'What you want to project',
    consignesExemple: 'Every declared candidate; or a scenario: this candidate runs, that one does not',
    sondages: 'The twins never read a poll: Orion only uses polls to calibrate the projection.',
    annuler: 'Cancel',
    creer: 'Orion reads up',
    erreur: 'The election could not be created.',
  },
}
